import { memo } from 'react';

import { useCaptureException } from '@zenbusiness/application-commons-logging';
import PropTypes from 'prop-types';

import Loader from '#client/components/MoveMoney/InstantDepositModal/components/Loader';
import {
  CHECK_CARD_ERRORS_STEP,
  CONFIRMATION_FORM_STEP,
  HOW_MUCH_STEP,
  IS_THAT_CORRECT_STEP,
  WHICH_ACCOUNT_STEP
} from '#client/constants/transfer';
import useToastContext from '#client/hooks/useToastContext';

import { AccountCouldNotSetUp } from './AccountCouldNotSetUp';
import { AddDestinationCardForm } from './AddDestinationCardForm';
import CheckCardError from './CheckCardError';
import ConfirmationForm from './ConfirmationForm';
import HowMuchForm from './HowMuchForm';
import IsThisCorrectForm from './IsThisCorrect';
import SettingUpAccount from './SettingUpAccount';
import WhichCardForm from './WhichCardForm';

import {
  LOADING_STEP,
  TRY_ADD_CARD_AGAIN_STEP,
  ACCOUNT_COULD_NOT_SET_UP,
  SETTING_UP_ACCOUNT
} from '../constants/instants';

const CurrentStep = ({ closeHandler, currentFormStep, actionsKit }) => {
  const { createCommonErrorToast } = useToastContext();
  const captureException = useCaptureException();

  const stepNotMatchHandler = () => {
    captureException(
      new Error(`Form step is not correct with currentFormStep: ${currentFormStep}`),
      {
        level: 'warning'
      }
    );
    createCommonErrorToast();
    return null;
  };

  const renderCurrentStep = () => {
    switch (currentFormStep) {
      case LOADING_STEP:
        return <Loader />;
      case SETTING_UP_ACCOUNT:
        return (
          <SettingUpAccount
            actionsKit={actionsKit}
            closeHandler={closeHandler}
          />
        );
      case ACCOUNT_COULD_NOT_SET_UP:
        return <AccountCouldNotSetUp />;
      case TRY_ADD_CARD_AGAIN_STEP:
        return <AddDestinationCardForm handleClose={closeHandler} />;
      case WHICH_ACCOUNT_STEP:
        return <WhichCardForm handleClose={closeHandler} />;
      case HOW_MUCH_STEP:
        return <HowMuchForm handleClose={closeHandler} />;
      case IS_THAT_CORRECT_STEP:
        return <IsThisCorrectForm />;
      case CONFIRMATION_FORM_STEP:
        return <ConfirmationForm handleClose={closeHandler} />;
      case CHECK_CARD_ERRORS_STEP:
        return <CheckCardError />;
      default:
        // show error toast and report error log
        return stepNotMatchHandler();
    }
  };

  return <>{renderCurrentStep()}</>;
};

const areEqual = (preProp, nextProp) =>
  preProp.isHandling === nextProp.isHandling &&
  preProp.currentFormStep === nextProp.currentFormStep;

CurrentStep.propTypes = {
  closeHandler: PropTypes.func.isRequired,
  currentFormStep: PropTypes.string.isRequired,
  actionsKit: PropTypes.shape({
    triggerInstantDepositFlow: PropTypes.func
  })
};

export default memo(CurrentStep, areEqual);
